<div class="page-content">

  <div class="page_header">
    <div class="page_header_text">
      <h1>Novo Cliente</h1>
      <span>Registe um novo cliente contratante</span>
    </div>
    <div class="page_header_actions">
      <button class="btn-web-secondary" (click)="voltar()">
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
      <button class="btn-web-primary" (click)="save()" [disabled]="saving">
        <i [class]="saving ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
        {{ saving ? "A criar..." : "Criar Cliente" }}
      </button>
    </div>
  </div>

  <input
    #fileInput
    type="file"
    accept="image/*"
    hidden
    (change)="onLogoChange($event)"
  />
  <input
    #contratoFileInput
    type="file"
    accept=".pdf,.doc,.docx,.xls,.xlsx,image/*"
    hidden
    (change)="onContratoFileChange($event)"
  />

  <form [formGroup]="form">
    <!-- ── IDENTIFICAÇÃO FISCAL ───────────────────────────────────── -->
    <div class="form-card">
      <div class="fc-header">
        <i class="fas fa-fingerprint"></i> Identificação Fiscal
      </div>
      <div class="fc-body">
        <div class="nif-hero">
          <div class="form-group" style="flex: 1">
            <label>NIF Fiscal <span class="req">*</span></label>
            <div class="nif-search-row">
              <input
                class="form-input nif-input"
                [class.is-error]="f['nif'].invalid && f['nif'].touched"
                formControlName="nif"
                placeholder="Ex: 5410003691"
              />
              <button
                type="button"
                class="btn-nif"
                (click)="pesquisarNif()"
                [disabled]="nifSearching"
                pTooltip="Pesquisar empresa pelo NIF na base de dados fiscal"
                tooltipPosition="top"
              >
                <i
                  [class]="
                    nifSearching ? 'fas fa-spinner fa-spin' : 'fas fa-search'
                  "
                ></i>
                {{ nifSearching ? "A pesquisar..." : "Pesquisar NIF" }}
              </button>
            </div>
            <small class="hint"
              >Pesquise pelo NIF para preencher automaticamente os dados da
              empresa.</small
            >
            <ng-container *ngIf="f['nif'].invalid && f['nif'].touched">
              <span class="sp-error" *ngIf="f['nif'].hasError('pattern')">
                <i class="fas fa-exclamation-triangle"></i> Apenas letras e números,
                sem espaços
              </span>
              <span class="sp-error" *ngIf="f['nif'].hasError('minlength')">
                <i class="fas fa-exclamation-triangle"></i> Mínimo 8 caracteres
              </span>
              <span class="sp-error" *ngIf="f['nif'].hasError('maxlength')">
                <i class="fas fa-exclamation-triangle"></i> Máximo 20 caracteres
              </span>
            </ng-container>
          </div>
        </div>

        <div class="form-divider"></div>

        <div class="fc-row-logo">
          <div
            class="logo-zone"
            (click)="triggerLogoInput()"
          >
            <img
              *ngIf="logoPreview"
              [src]="logoPreview"
              class="logo-img"
              alt="Fotografia"
            />
            <div *ngIf="!logoPreview" class="logo-empty">
              <i class="fas fa-image"></i>
              <span>Fotografia</span>
            </div>
            <div class="logo-overlay"><i class="fas fa-camera"></i></div>
          </div>

          <div class="form-group" style="flex: 1">
            <label>Nome da Empresa / Cliente <span class="req">*</span></label>
            <input
              class="form-input"
              [class.is-error]="f['nome'].invalid && f['nome'].touched"
              formControlName="nome"
              placeholder="Ex: Banco BFA, S.A."
            />
            <ng-container *ngIf="f['nome'].invalid && f['nome'].touched">
              <span class="sp-error" *ngIf="f['nome'].hasError('required')">
                <i class="fas fa-exclamation-triangle"></i> Campo obrigatório
              </span>
              <span class="sp-error" *ngIf="f['nome'].hasError('minlength')">
                <i class="fas fa-exclamation-triangle"></i> Mínimo 2 caracteres
              </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- ── INFORMAÇÃO COMERCIAL ───────────────────────────────────── -->
    <div class="form-card" *ngIf="!isNifPessoaSingular()">
      <div class="fc-header">
        <i class="fas fa-briefcase"></i> Informação Comercial
      </div>
      <div class="fc-body">
        <div class="form-grid-2">
          <div class="form-group" *ngIf="!isNifPessoaSingular()">
            <label>Sector de Actividade</label>
            <p-select
              formControlName="sector"
              [options]="sectors"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar sector"
              styleClass="w-full"
              appendTo="body"
            >
            </p-select>
          </div>
          <div class="form-group" *ngIf="!isNifPessoaSingular()">
            <label>Website <span class="req">*</span></label>
            <div class="input-prefix-wrap">
              <span class="input-prefix"><i class="fas fa-globe"></i></span>
              <input
                class="form-input prefixed"
                [class.is-error]="f['website'].invalid && f['website'].touched"
                formControlName="website"
                placeholder="www.empresa.ao"
              />
            </div>
            <span
              class="sp-error"
              *ngIf="f['website'].hasError('pattern') && f['website'].touched"
            >
              <i class="fas fa-exclamation-triangle"></i> URL inválido (ex:
              www.empresa.ao)
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ── INFORMAÇÃO DE CONTACTO ─────────────────────────────────── -->
    <div class="form-card">
      <div class="fc-header">
        <i class="fas fa-address-book"></i> Informação de Contacto
      </div>
      <div class="fc-body">
        <div class="form-grid-2">
          <div class="form-group">
            <label>Telefone <span class="req">*</span></label>
            <div class="input-prefix-wrap">
              <span class="input-prefix"><i class="fas fa-phone"></i></span>
              <input
                class="form-input prefixed"
                type="tel"
                [class.is-error]="
                  f['numTelefone'].invalid && f['numTelefone'].touched
                "
                formControlName="numTelefone"
                placeholder="923 000 000"
                (input)="formatPhone($event)"
              />
            </div>
            <span
              class="sp-error"
              *ngIf="
                f['numTelefone'].hasError('pattern') && f['numTelefone'].touched
              "
            >
              <i class="fas fa-exclamation-triangle"></i> Apenas dígitos, espaços ou +
              ( ) —
            </span>
          </div>
          <div class="form-group">
            <label>E-mail <span class="req">*</span></label>
            <div class="input-prefix-wrap">
              <span class="input-prefix"><i class="fas fa-envelope"></i></span>
              <input
                class="form-input prefixed"
                type="email"
                [class.is-error]="f['email'].invalid && f['email'].touched"
                formControlName="email"
                placeholder="geral@empresa.ao"
              />
            </div>
            <span
              class="sp-error"
              *ngIf="f['email'].hasError('email') && f['email'].touched"
            >
              <i class="fas fa-exclamation-triangle"></i> Formato de e-mail inválido
            </span>
          </div>
          <div class="form-group">
            <label>Nome do Responsável <span class="req">*</span></label>
            <div class="input-prefix-wrap">
              <span class="input-prefix"
                ><i class="fas fa-user-shield"></i
              ></span>
              <input
                class="form-input prefixed"
                formControlName="nomeResponsavel"
                placeholder="Nome completo"
              />
            </div>
          </div>
          <div class="form-group">
            <label>Endereço <span class="req">*</span></label>
            <div class="input-prefix-wrap">
              <span class="input-prefix"><i class="fas fa-map-marker-alt"></i></span>
              <input
                class="form-input prefixed"
                formControlName="endereco"
                placeholder="Rua, nº, município"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- ── CONTRATO INICIAL (opcional) ────────────────────────────── -->
  <div class="form-card contrato-card">
    <div class="fc-header">
      <i class="fas fa-file-invoice"></i> Contrato Inicial
      <span class="fc-opt">opcional</span>
    </div>

    <div class="fc-body">
      <!-- Toggle -->
      <div class="contrato-toggle" (click)="criarContrato = !criarContrato">
        <div class="toggle-track" [class.on]="criarContrato">
          <div class="toggle-thumb"></div>
        </div>
        <span class="toggle-label">
          {{
            criarContrato
              ? "Gerar contrato para este cliente"
              : "Gerar contrato para este cliente"
          }}
        </span>
        <span class="toggle-state" [class.active]="criarContrato">
          {{ criarContrato ? "Activado" : "Desactivado" }}
        </span>
      </div>

      <!-- Expandable fields -->
      <div class="contrato-fields" [class.expanded]="criarContrato">
        <form [formGroup]="contratoForm">
          <div class="form-divider"></div>

          <p class="form-section-title">
            <i class="fas fa-coins"></i> Condições Contratuais
          </p>

          <div class="form-group cn-tipo-servico">
            <label>Tipo de Serviço <span class="req">*</span></label>
            <p-select
              formControlName="tipoServico"
              [options]="tiposServico"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar tipo de serviço"
              styleClass="w-full"
              appendTo="body"
            >
            </p-select>
            <span
              class="sp-error"
              *ngIf="
                cf['tipoServico'].invalid && cf['tipoServico'].touched
              "
            >
              Campo obrigatório
            </span>
          </div>

          <div class="form-group">
            <label>Modelo de Cobrança <span class="req">*</span></label>
            <p-select
              formControlName="modeloCobranca"
              [options]="modeloCobrancas"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar modelo"
              styleClass="w-full"
              appendTo="body"
              (onChange)="onModeloChange($event)"
            >
            </p-select>
          </div>

          <ng-container [ngSwitch]="modeloCobranca">
            <!-- FIXO MENSAL -->
            <ng-container *ngSwitchCase="'fixo_mensal'">
              <div class="form-grid-2 cn-billing-fields">
                <div class="form-group">
                  <label>Valor Mensal (Kz) <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="valorMensal"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 5 000 000"
                    styleClass="w-full form-inputnumber"
                    suffix=" Kz"
                  >
                  </p-inputNumber>
                </div>
                <div class="form-group">
                  <label>Nº de Postos</label>
                  <p-inputNumber
                    formControlName="numPostos"
                    [min]="0"
                    styleClass="w-full form-inputnumber"
                  >
                  </p-inputNumber>
                </div>
              </div>

              <!-- Financial preview -->
              <div
                class="cn-finance-preview"
                *ngIf="(cf['valorMensal'].value || 0) > 0"
              >
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="ri-calendar-line"></i> Valor Mensal</span>
                  <span class="cn-fp-val">{{ fmtKz(cf["valorMensal"].value) }}</span>
                </div>
                <div class="cn-fp-sep"></div>
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
                  <span class="cn-fp-val strong">{{ fmtKz((cf["valorMensal"].value || 0) * 12) }}</span>
                </div>
              </div>
            </ng-container>

            <!-- POR EFETIVO -->
            <ng-container *ngSwitchCase="'por_efetivo'">
              <div class="form-grid-2 cn-billing-fields">
                <div class="form-group">
                  <label>Valor unitário (Kz) <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="valorUnitario"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 50 000"
                    styleClass="w-full form-inputnumber"
                    suffix=" Kz"
                  >
                  </p-inputNumber>
                </div>
                <div class="form-group">
                  <label>Nº de efectivos <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="numEfetivos"
                    [min]="0"
                    styleClass="w-full form-inputnumber"
                  >
                  </p-inputNumber>
                </div>
              </div>

              <!-- Financial preview -->
              <div class="cn-finance-preview" *ngIf="totalMensalCalculado > 0">
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="ri-calendar-line"></i> Total Mensal</span>
                  <span class="cn-fp-val strong">{{ fmtKz(totalMensalCalculado) }}</span>
                </div>
                <div class="cn-fp-sep"></div>
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
                  <span class="cn-fp-val">{{ fmtKz(totalMensalCalculado * 12) }}</span>
                </div>
              </div>
            </ng-container>

            <!-- POR POSTO -->
            <ng-container *ngSwitchCase="'por_posto'">
              <div class="form-grid-2 cn-billing-fields">
                <div class="form-group">
                  <label>Valor unitário (Kz) <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="valorUnitario"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 200 000"
                    styleClass="w-full form-inputnumber"
                    suffix=" Kz"
                  >
                  </p-inputNumber>
                </div>
                <div class="form-group">
                  <label>Nº de postos <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="numPostos"
                    [min]="0"
                    styleClass="w-full form-inputnumber"
                  >
                  </p-inputNumber>
                </div>
              </div>

              <!-- Financial preview -->
              <div class="cn-finance-preview" *ngIf="totalMensalCalculado > 0">
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="ri-calendar-line"></i> Total Mensal</span>
                  <span class="cn-fp-val strong">{{ fmtKz(totalMensalCalculado) }}</span>
                </div>
                <div class="cn-fp-sep"></div>
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
                  <span class="cn-fp-val">{{ fmtKz(totalMensalCalculado * 12) }}</span>
                </div>
              </div>
            </ng-container>

            <!-- POR HORA -->
            <ng-container *ngSwitchCase="'por_hora'">
              <div class="form-grid-2 cn-billing-fields">
                <div class="form-group">
                  <label>Valor por hora (Kz) <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="valorUnitario"
                    [min]="0"
                    [useGrouping]="true"
                    placeholder="Ex: 5 000"
                    styleClass="w-full form-inputnumber"
                    suffix=" Kz"
                  >
                  </p-inputNumber>
                </div>
                <div class="form-group">
                  <label>Nº de horas / mês <span class="req">*</span></label>
                  <p-inputNumber
                    formControlName="numHoras"
                    [min]="0"
                    styleClass="w-full form-inputnumber"
                  >
                  </p-inputNumber>
                </div>
              </div>

              <!-- Financial preview -->
              <div class="cn-finance-preview" *ngIf="totalMensalCalculado > 0">
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="ri-calendar-line"></i> Total Mensal</span>
                  <span class="cn-fp-val strong">{{ fmtKz(totalMensalCalculado) }}</span>
                </div>
                <div class="cn-fp-sep"></div>
                <div class="cn-fp-item">
                  <span class="cn-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
                  <span class="cn-fp-val">{{ fmtKz(totalMensalCalculado * 12) }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <span
            class="sp-error"
            *ngIf="
              contratoForm.hasError('modeloIncompleto') &&
              contratoForm.touched
            "
          >
            <i class="fas fa-exclamation-triangle"></i> Preencha correctamente
            os valores do modelo de cobrança seleccionado
          </span>

          <div class="form-divider"></div>

          <p class="form-section-title">
            <i class="fas fa-calendar-alt"></i> Período do Contrato
          </p>
          <div class="form-grid-3">
            <div class="form-group">
              <label>Data de Início <span class="req">*</span></label>
              <p-datepicker [showIcon]="true"
                formControlName="inicioContrato"
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
              >
              </p-datepicker>
              <span
                class="sp-error"
                *ngIf="
                  cf['inicioContrato'].invalid && cf['inicioContrato'].touched
                "
              >
                <i class="fas fa-exclamation-triangle"></i> Campo obrigatório
              </span>
            </div>
            <div class="form-group">
              <label>Data de Fim <span class="req">*</span></label>
              <p-datepicker [showIcon]="true"
                formControlName="fimContrato"
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
              >
              </p-datepicker>
              <span
                class="sp-error"
                *ngIf="cf['fimContrato'].invalid && cf['fimContrato'].touched"
              >
                <i class="fas fa-exclamation-triangle"></i> Campo obrigatório
              </span>
            </div>
            <div class="form-group">
              <label>Data de Facturação</label>
              <p-datepicker [showIcon]="true"
                formControlName="dataFaturacao"
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
              >
              </p-datepicker>
            </div>
          </div>
          <span
            class="sp-error date-range-error"
            *ngIf="
              contratoForm.hasError('fimAnterior') && cf['fimContrato'].touched
            "
          >
            <i class="fas fa-exclamation-triangle"></i> A data de fim deve ser
            posterior à data de início
          </span>

          <!-- Duration pill -->
          <div class="duracao-pill" *ngIf="duracaoMeses > 0">
            <i class="fas fa-calendar-check"></i>
            Duração:
            <strong
              >{{ duracaoMeses }} mes{{
                duracaoMeses !== 1 ? "es" : ""
              }}</strong
            >
          </div>

          <div class="form-divider"></div>

          <p class="form-section-title">
            <i class="fas fa-file-invoice"></i> Documento do Contrato
            <span class="cd-opt">opcional</span>
          </p>

          <div
            class="cd-upload-zone"
            (click)="triggerContratoFileInput()"
            [class.has-file]="contratoFile"
          >
            <!-- Estado: sem ficheiro -->
            <ng-container *ngIf="!contratoFile">
              <div class="cd-uz-icon">
                <i class="fas fa-cloud-upload-alt"></i>
              </div>
              <div class="cd-uz-text">
                <span>Clique para anexar o documento do contrato</span>
                <small>PDF, Word, Excel ou imagem</small>
              </div>
            </ng-container>

            <!-- Estado: com ficheiro -->
            <ng-container *ngIf="contratoFile">
              <div class="cd-uz-icon file">
                <i class="fas fa-file-signature"></i>
              </div>
              <div class="cd-uz-text">
                <span>{{ contratoFile.name }}</span>
                <small>{{ formatBytes(contratoFile.size) }}</small>
              </div>
              <button
                type="button"
                class="cd-uz-remove"
                (click)="removeContratoFile($event)"
                pTooltip="Remover ficheiro"
                tooltipPosition="top"
              >
                <i class="fas fa-times"></i>
              </button>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Footer actions -->
  <div class="form-actions">
    <button type="button" class="btn-web-secondary" (click)="voltar()">
      Cancelar
    </button>
    <button
      type="button"
      class="btn-web-primary"
      (click)="save()"
      [disabled]="saving"
    >
      <i [class]="saving ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
      {{ saving ? "A criar..." : "Criar Cliente" }}
    </button>
  </div>
</div>
